<app-crud-create [fields]="fields" [title]="'plan'"
  [description]="'En esta sección podrás ingresar el detalle del Plan'" [apiService]="planesService">
</app-crud-create>
